const loader = require("./composer/loader");

//load the libraries
loader.default().then(() => {
    const composer = require("./composer/composer");
    composer.default();
});
